<ca-table [ngClass]="{ 'my-files': myFilesClass, 'my-files-header': !stickyHeader }" data-uit="results-table" class="mb-2">
    <thead *ngIf="showTableHead && !isEmptyAndModificationMode()">
        <tr>
            <th *ngIf="isCheckboxIncluded()" class="col-checkbox pe-0 ps-0">
                <span>
                    <ca-input-checkbox
                        [style.visibility]="isEmptyAndModificationMode() ? 'hidden' : 'visible'"
                        data-uit="select-all-checkbox"
                        [checked]="areAllFilesSelected"
                        (change)="onSelectAllRowsChange()"
                    ></ca-input-checkbox>
                </span>
            </th>
            <th *ngIf="isFileStatusIncluded()" class="col-checkbox"></th>
            <th class="col-name">
                <span>
                    <div *ngIf="!areSomeRowsSelected" class="d-flex flex-row align-items-center">
                        <span class="me-2 white-space-no-wrap without-border">{{ 'GENERAL.COLUMN.NAME' | translate }}</span>
                    </div>
                    <div *ngIf="areSomeRowsSelected" class="d-flex flex-row align-items-center">
                        <span class="white-space-no-wrap no-underline">{{ tableBannerText }}</span>
                        <div class="d-flex flex-row" data-uit="files-table-action-container">
                            <button
                                *ngIf="actions.includes('view') && isAtLeastOneArivisPreviewableFileSelected()"
                                type="button"
                                class="btn ca-btn-icon ms-2"
                                (click)="openSelectedFilesInArivis()"
                                caTrackClick="previewFileOrResult"
                                data-uit="result-file-preview-btn"
                                [ngbTooltip]="'GENERAL.PREVIEW' | translate"
                                placement="auto"
                            >
                                <ca-icon name="eye-open" size="s"></ca-icon>
                            </button>
                            <ca-file-download-btn
                                *ngIf="actions.includes('download') && isDownloadBtnEnabled() && isLoggedIn"
                                (onClick)="downloadSelectedFiles()"
                                [title]="'FILES_TABLE.DOWNLOAD_SELECTED_FILES' | translate"
                                placement="auto"
                            ></ca-file-download-btn>
                            <button
                                *ngIf="actions.includes('delete')"
                                type="button"
                                (click)="onDeleteSelectedResults()"
                                class="btn ca-btn-icon"
                                data-uit="result-detail-delete-button"
                                [ngbTooltip]="'GENERAL.DELETE' | translate"
                            >
                                <ca-icon name="trash" size="s"></ca-icon>
                            </button>
                        </div>
                    </div>
                </span>
            </th>
            <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="!(column.key === 'shares' && !showShareColumn)">
                    <ng-container *ngIf="column.translationKey">
                        <th>
                            <span class="th-col-size">
                                {{ column.translationKey | translate }}
                            </span>
                        </th>
                    </ng-container>
                </ng-container>
            </ng-container>
        </tr>
    </thead>
    <tbody id="results-table-body" [ngClass]="{ 'empty-body': isEmptyAndModificationMode() }" data-uit="results-table-body">
        <tr
            *ngFor="let row of rows; let first = first; let index = index"
            class="group-child-row"
            [ngClass]="{
                'group-child-row-first-in-group': first,
                'is-submenu-open': fileItemSubMenuOpenIndex === index || folderItemSubMenuOpenIndex === index,
            }"
            (click)="handleRowClick(row, $event)"
            data-uit="results-table-file-row"
            attr.data-rowIsFolder="{{ row.item.isFolder }}"
            attr.data-targetFolderId="{{ row.item.isFolder ? row.workflowResultGroupId : folderId }}"
            attr.data-rowId="{{ row.item.id }}"
            ondragover="event.preventDefault()"
            #trRef
        >
            <td *ngIf="isCheckboxIncluded()" class="me-0 pe-0 ps-0">
                <span class="me-0">
                    <ca-input-checkbox
                        data-uit="result-file-selected"
                        [ngClass]="{ checked: row.selected }"
                        [checked]="row.selected"
                        (change)="onRowCheckboxChange(row)"
                        (click)="$event.stopPropagation()"
                    ></ca-input-checkbox>
                </span>
            </td>
            <td class="ps-0">
                <span class="ps-0">
                    <ca-results-file-actions
                        #parent
                        [index]="index"
                        [isFolder]="row.item.isFolder"
                        [isSelected]="row.selected"
                        [mode]="mode"
                        [item]="row.item"
                        [truncateFileNameAtWidthOf]="truncateFileNameAtWidthOf"
                        [actions]="actions"
                        [showFileStatus]="showFileStatus"
                        (onOpenFolder)="onOpenFolder.emit($event)"
                        (deleteItems)="deleteItems.emit($event)"
                        class="w-100"
                    >
                        <ca-file-item-submenu
                            *ngIf="!row.isFolder"
                            data-uit="result-file-item-submenu"
                            [ngClass]="{ checked: row.selected, isFolder: row.item.isFolder }"
                            [fileModel]="parent.item"
                            [isPreviewBtnEnabled]="isPreviewBtnEnabled(parent.item)"
                            [isDownloadBtnEnabled]="isDownloadBtnEnabled()"
                            [isDeleteBtnEnabled]="isDeleteBtnEnabled()"
                            (previewFile)="parent.openFile($event)"
                            (deleteItems)="onDeleteItemsFromChild($event)"
                            (openChange)="onFileItemSubMenuOpen(index, $event)"
                        ></ca-file-item-submenu>
                        <ca-folder-item-submenu
                            *ngIf="row.isFolder"
                            data-uit="result-folder-item-submenu"
                            [ngClass]="{ checked: row.selected, isFolder: row.item.isFolder }"
                            [fileModel]="parent.item"
                            [isDownloadBtnEnabled]="false"
                            [isDeleteBtnEnabled]="isItMY(row.item)"
                            [isShareBtnEnabled]="isItMY(row.item)"
                            (openChange)="onFolderItemSubMenuOpen(index, $event)"
                            (openSharing)="onSharing(row.item)"
                            (deleteItems)="onDeleteItemsFromChild($event)"
                        ></ca-folder-item-submenu>
                    </ca-results-file-actions>
                </span>
            </td>
            <ng-container *ngFor="let column of columns">
                <ng-container *ngIf="row.item.isFolder || column.key !== 'shares'">
                    <ng-container *ngIf="column.key !== 'checkbox'">
                        <td>
                            <span [ngSwitch]="column.transform">
                                <ng-container *ngSwitchCase="'resultDate'" data-uit="result-file-created-at">
                                    {{ (row.item[column.key] | resultDate: column.transformDateFormat) || getDefaultColumnValue(column.key) }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'fileSize'">
                                    <ng-container *ngIf="row.item.isFolder">
                                        {{ getDefaultColumnValue(column.key) }}
                                    </ng-container>
                                    <ng-container *ngIf="!row.item.isFolder">
                                        {{ (row.item[column.key] | fileSize) || getDefaultColumnValue(column.key) }}
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngSwitchCase="'titlecase'">
                                    {{ (row.item[column.key] | titlecase) || getDefaultColumnValue(column.key) }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'shares'">
                                    <ng-container *ngIf="row.item.shares[0].users?.length > 0; else noShares">
                                        <ca-shared-with [sharedWithUsers]="row.item.shares[0].users" [ownerId]="row.item.userId"></ca-shared-with>
                                    </ng-container>
                                    <ng-template #noShares>
                                        {{ getDefaultColumnValue(column.key) }}
                                    </ng-template>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    {{ row.item[column.key] || getDefaultColumnValue(column.key) }}
                                </ng-container>
                            </span>
                        </td>
                    </ng-container>
                </ng-container>
            </ng-container>
        </tr>
        <!--This is empty placeholder row used when there are only folders in the current folder in order to be able to upload files by dropping to the current folder tbody-->
        <ng-container *ngIf="showEmptyRows && rows?.length > 0 && rows?.length < 10">
            <tr
                *ngFor="let i of Array.from(Array(10 - rows.length).keys())"
                class="upload-row placeholder-file-row"
                attr.data-rowIsFolder="false"
                attr.data-targetFolderId="{{ folderId }}"
            >
                <td colspan="6"></td>
            </tr>
        </ng-container>
    </tbody>
</ca-table>
